import { render, staticRenderFns } from "./serverDate.vue?vue&type=template&id=07d88a2c&scoped=true"
import script from "./serverDate.vue?vue&type=script&lang=js"
export * from "./serverDate.vue?vue&type=script&lang=js"
import style0 from "./serverDate.vue?vue&type=style&index=0&id=07d88a2c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d88a2c",
  null
  
)

export default component.exports